import type { ReactNode } from "react";

/**
 * Shell para todas las pantallas de auth (login, reset, etc).
 * Brand wall + tarjeta con marca, tag y footer.
 *
 * Portado del diseño de `lambda/code/frontend/issuer/src/pages/auth/AuthShell.tsx`,
 * adaptado a Sovra Log (sin Firebase, sin botón de "register").
 */
export function AuthShell({ tag, children }: { tag: string; children: ReactNode }) {
  return (
    <div className="login-page">
      <div className="login-backdrop" />

      <aside className="login-brand">
        <div className="login-brand-inner">
          <div className="login-logo" style={{ alignSelf: "flex-start" }}>Sovra Log</div>
          <div style={{ flex: 1 }} />
          <div style={{ maxWidth: 440 }}>
            <div className="login-brand-headline">
              Observabilidad del trámite,<br />
              del backend a la API externa.
            </div>
            <p className="login-brand-lede">
              Rastreá cada llamada a servicios externos desde tus Cloud Functions.
              Ve incidentes en vivo y status histórico por endpoint.
            </p>
            <div className="login-brand-badges">
              <span className="badge badge-muted">HMAC ingest</span>
              <span className="badge badge-muted">TimescaleDB</span>
              <span className="badge badge-muted">Phoenix Channels</span>
            </div>
          </div>
          <div style={{ flex: 1 }} />
          <div className="login-brand-footer">
            <span>© 2026 Sovra</span>
            <span>sovra.io/logs</span>
          </div>
        </div>
      </aside>

      <div className="login-form-wrap">
        <div className="login-card">
          <div className="login-header">
            <span className="login-logo" style={{ fontSize: 18 }}>Sovra Log</span>
            <span className="tag">{tag}</span>
          </div>
          {children}
        </div>

        <div className="login-card-footer">
          Al continuar aceptás los <a href="#">Términos</a> y la{" "}
          <a href="#">Política de privacidad</a> de Sovra.
        </div>
      </div>
    </div>
  );
}
